import t from"react";var r=t.createContext((function(t){return!t}));export{r as default};
